(() => {
  if (window.greenpanCEOVideoInitialized) return;
  window.greenpanCEOVideoInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ceo-play]');
    if (!button) return;
    const container = button.closest('[data-ceo-player]');
    const video = container.querySelector('[data-ceo-video]');
    const error = container.querySelector('[data-ceo-error]');
    error.hidden = true;
    button.disabled = true;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    try {
      await video.play();
      button.hidden = true;
      video.controls = true;
      video.focus();
    } catch (_) {
      error.hidden = false;
      button.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  document.addEventListener('play', (event) => {
    if (!event.target.matches('[data-ceo-video]')) return;
    event.target.closest('[data-ceo-player]').querySelector('[data-ceo-play]').hidden = true;
    window._fpEvent = window._fpEvent || [];
    window._fpEvent.push(['eventConversion', { value: 'ceo_video_played' }]);
  }, true);
})();
